import {
  percentageToInches,
  getCoordinates,
  hasProperty,
  getTextValues,
  decodeHtml,
  SLIDE_SIZE_PX,
} from '../helpers'
import { SANS_SERIF } from '../common/constants'

function getTextWidth(text, fontSize) {
  if (text == 'Social Channels' || text == 'Recent Trends') {
    return text.length * (fontSize - 5)
  } else if (text.includes('COMPETITOR SENTIMENT DISTRIBUTION (%):')) {
    return text.length * fontSize
  } else if (text.length <= 20) {
    return text.length * fontSize
  } else if (text.length <= 30) {
    return text.length * (fontSize - 2)
  } else if (text.length > 80) {
    return (text.length / 1.9) * fontSize
  }
  return (text.length / 1.5) * fontSize
}

function getTextColor(svgNode) {
  if (hasProperty('fill', svgNode)) {
    const color = svgNode.properties.fill.substring(1)

    if (color.length === 3) {
      return color
        .split('')
        .map((digit) => digit + digit)
        .join('')
    }

    return color
  }

  return '505050'
}

function getStylesObject(style) {
  const utf8Style = style.replace(/&quot;/g, '\\"')
  const properties = utf8Style.split(';')
  const stylesObj = {}
  for (const property of properties) {
    if (property.includes(':')) {
      const splitProperty = property.split(':')
      const propertyName = splitProperty[0].trim()
      const propertyValue = splitProperty[1].trim()

      stylesObj[propertyName] = propertyValue
    }
  }

  return stylesObj
}

function renderSvgText({ x, y, height, width, parent, translateX, translateY, svgNode, slide }) {
  const coordinates = getCoordinates(
    { x: x + translateX, y: y + translateY, height, width },
    parent
  )

  const styles = hasProperty('style', svgNode) ? getStylesObject(svgNode.properties.style) : {}
  const color = styles.fill ? styles.fill.substring(1) : getTextColor(svgNode)
  const lines = getTextValues(svgNode)
  const text = decodeHtml(lines.join(' ')).replaceAll(/\n/g, ' ')

  const elementFontSize = svgNode.properties['font-size'] || parseInt(styles['font-size'])
  const fontSize = elementFontSize * 0.4 // Magic number. Based on scale 2x set to SVGs and visual adjust

  const isHorizontallyMiddleCentered = svgNode.properties['text-anchor'] === 'middle'
  const isVerticallyMiddleCentered = svgNode.properties['alignment-baseline'] === 'middle'
  const dataWidth = svgNode.properties['data-width']
  // Necessary to get width for WordCloud and `text` elements that happens to not have data-width attribute
  const biggerTextWidth = Math.max(
    ...(text ? lines.map((textValue) => (getTextWidth(textValue, fontSize) * 0.75) / 72) : [0])
  )
  const w = dataWidth ? percentageToInches(dataWidth / SLIDE_SIZE_PX.x, 'x') : biggerTextWidth

  const textHeight = percentageToInches((fontSize / 4 / 100) * svgNode.children.length * 1.4, 'y')

  const style = {
    x: coordinates.x - (isHorizontallyMiddleCentered ? w / 2 : 0),
    y: coordinates.y - (isVerticallyMiddleCentered ? textHeight / 2 : 0) - 0.04, // 0.04 is a magic number to move every text a little bit up
    h: textHeight,
    w,
    fontSize,
    inset: 0,
    margin: 0,
    bold: svgNode.properties['font-weight'] > 400,
    italic: svgNode.properties['font-style'] === 'italic',
    fontFace: SANS_SERIF,
    align: isHorizontallyMiddleCentered ? 'center' : 'left',
    color,
  }

  slide.addText(text, style)
}

export default renderSvgText
